"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PriceEvaluation {
    getEvaluationType() {
        return this.evaluationType;
    }
    setEvaluationType(value) {
        this.evaluationType = value;
        return this;
    }
    getEvaluationValue() {
        return this.evaluationValue;
    }
    setEvaluationValue(value) {
        this.evaluationValue = value;
        return this;
    }
}
exports.default = PriceEvaluation;
